"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_base_1 = __importDefault(require("./api_base"));
exports.default = {
    get: function (userId, orgId) {
        return api_base_1.default.get("users/" + userId + "/organizations/" + orgId + "/accessible_reports").then(function (response) {
            return response.data.data;
        });
    }
};
//# sourceMappingURL=users_accessible_reports_api.js.map